import SiteInertiaController from '@/actions/App/Http/Controllers/SiteInertiaController';
import { ErrorBoundary } from '@/components/error-boundary';
import { Toaster } from '@/components/ui/sonner';
import WebLayoutTemplate from '@/components/web/layouts/web-layout-template';
import { cn } from '@/lib/utils';
import { type BreadcrumbItem } from '@/types';
import { Link } from '@inertiajs/react';
import { type ReactNode } from 'react';

interface PolicyLayoutProps {
  children: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  posts: Array<{
    id: number;
    title: string;
    slug: string;
  }>;
  currentSlug: string;
}

export default function PolicyLayout({ children, breadcrumbs, posts = [], currentSlug, ...props }: PolicyLayoutProps) {
  return (
    <ErrorBoundary>
      <WebLayoutTemplate breadcrumbs={breadcrumbs} {...props}>
        <div className="container mx-auto max-w-6xl px-4 py-8 md:py-16">
          <div className="flex flex-col gap-8 md:flex-row lg:gap-16">
            <aside className="w-full shrink-0 md:sticky md:top-24 md:h-fit md:w-1/4">
              <nav className="flex flex-col space-y-1">
                {posts.map((post) => (
                  <Link
                    key={post.id}
                    href={SiteInertiaController.policyPage(post.slug).url}
                    className={cn(
                      'border-l-4 px-4 py-2 font-medium transition-all duration-200',
                      currentSlug === post.slug ? 'text-primary border-primary' : 'border-transparent text-gray-500 hover:text-gray-900',
                    )}
                  >
                    {post.title}
                  </Link>
                ))}
              </nav>
            </aside>

            <main className="max-w-4xl flex-1">
              <div className="prose prose-slate max-w-none">{children}</div>
            </main>
          </div>
        </div>
        <Toaster position="top-right" theme="light" richColors />
      </WebLayoutTemplate>
    </ErrorBoundary>
  );
}
